import ReactModal from 'react-modal';
import React, {Component} from 'react';
import Cookies from 'universal-cookie';
import {connect} from "react-redux";

class CookieGDPR extends Component {
    constructor(props) {
        super(props);

        const show = new Cookies().get("gdpr");

        this.state = {
            show: show == null || show === undefined
        };
    }

    accept = () => {
        let d = new Date();

        new Cookies().set('gdpr', 'true', {
            path: '/',
            expires: new Date(d.getFullYear() + 1, d.getMonth(), d.getDate())
        });
        this.setState({show: false})
    };


    render() {
        const i18n = this.props.i18n;


        return (
            <ReactModal
                className="popup"
                overlayClassName="popup-overlay"
                isOpen={this.state.show}
            >
                <div className="popup-title">
                    {i18n['gdprModal.title']}
                </div>
                <div dangerouslySetInnerHTML={{__html: i18n['gdprModal.contentHtml']}}
                     style={{minHeight: '100px'}}></div>

                <br/><br/>

                <div style={{textAlign: 'center'}}>
                    <button onClick={this.accept} className="btn btn-border">
                        {i18n['gdprModal.accept']}
                    </button>
                </div>
            </ReactModal>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CookieGDPR);



// WEBPACK FOOTER //
// ./src/components/Base/CookieGDPR.js